<template>
	<div class="mainContent dashboard">

		<div class="planSummaryWrap" v-if="fullAmountValue !== null">
			<div ref="planSummary" class="planSummary frameMobile center">
				<div class="titleWrap">
					<h2><span v-if="$mq=='lg'">{{'pages/home.your' | trans}} </span>{{'pages/home.plan-summary' | trans}}</h2>
				</div>

				<PulseLoader v-if="paymentInstalmentLoading" size="8px" color="#00B2FF"/>
				<div v-else class="summaryDescription">

					<div class="summaryDescriptionContent" :class="{ 'fullWidth' : !fullAmountValue }">
						<div v-if="instalmentTerm && instalmentTerm != 999 && fullAmountValue > 0">
							<div class="title">{{instalmentTerm}} monthly instalments of</div>
							<div class="value">{{(typeof user.instalment.symbol !== 'undefined') ? user.instalment.symbol : ''}}{{instalmentAmountValue}} p/m</div>
							<div v-if="dueDate" class="desc">
								{{'pages/home.monthly-instalment-are-made' | trans({date: dueDate }) }}
							</div>

						</div>
						<div v-else>
							<div v-if="fullAmountValue > 0" class="title smaller">
								{{'pages/home.monthly-instalment-not-available' | trans }}
							</div>
							<div v-else-if="fullAmountValue !== null && fullAmountValue < 0.01" class="title smaller">
								{{'pages/home.account-is-settled' | trans }}
							</div>
						</div>
					</div>
					<router-link v-if="fullAmountValue" to="/payment" class="btn btn-block">{{'pages/home.make-payment' | trans }}</router-link>
				</div>
			</div>
		</div>
		<PulseLoader v-else-if="fullAmountValue === null" size="8px" color="#00B2FF" class="center"/>
		<PulseLoader v-else-if="userInfoLoading" size="8px" color="#00B2FF" class="center"/>


		<div class="recentTransactions frameMobile">
			<h2>{{'pages/home.recent-transactions' | trans }}</h2>
			<div class="transactions" style="margin-bottom: 10px">
				<transaction
					v-for="transaction in recentTransaction"
					:key="transaction.id"
					v-bind="transaction"
				/>
			</div>
			<PulseLoader v-if="moreTransactionsLoading || transactionsLoading" size="8px" color="#00B2FF"
						 class="center"/>
			<div v-else>
				<div v-if="displayShowMoreButton" class="loadMore center">
					<button
						@click="showMoreTransactions"
						class="btnSec"
					>{{'pages/home.show-more-transactions' | trans }}
					</button>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
    import {mapState, mapActions} from 'vuex';
    import Transaction from '../components/Transactions/Transaction';
    import PulseLoader from 'vue-spinner/src/PulseLoader.vue';

    export default {
        data() {
            return {
                start: 0,
                end: 5,
                transactionLoadLimit: 5,
                instalmentAmountValue: null,
                instalmentTerm: null,
                fullAmountValue: null,
                displayShowMoreButton: true,
                moreTransactionsLoading: false,
                loadDuration: 500,
				dueDate: null
            }
        },
        methods: {
            ...mapActions(['getPaymentInstalment', 'loadMoreTransactions', 'addMessage']),
            showMoreTransactions: function () {
                this.moreTransactionsLoading = true;
                setTimeout(() => {
                    this.end += this.transactionLoadLimit;
                }, this.loadDuration)
            },
        },
        computed: {
            ...mapState(['transactions', 'transactionsLoading', 'transactionsShowMore', 'paymentInstalmentLoading', 'user', 'userInfoLoading']),
            recentTransaction: function () {
                return this.transactions.slice(this.start, this.end);
            }
        },
        components: {Transaction, PulseLoader},
        mounted() {

            if (!this.transactions.length) {
                this.$store.dispatch('getTransactions');
            }
            this.end = this.transactionLoadLimit;
        },
        watch: {
            end: function () {
                this.displayShowMoreButton = this.transactions.length > this.end;
                this.moreTransactionsLoading = false;
            },
            transactions: function () {
                this.end = this.end * 1;
            },
            user: function () {
                this.instalmentAmountValue = this.user && this.user.instalment ? parseFloat(this.user.instalment.amount) : 0;
                this.instalmentTerm = this.user && this.user.instalment ? parseFloat(this.user.instalment.term) : 0;
                this.fullAmountValue = this.user ? parseFloat(this.user.account_balance) : 0;
                this.dueDate = this.user.due_date_frontend;
            },
        },
        updated: function () {
            this.$nextTick(function () {
                //plan summary component on mobile dynamic height
                checkWindowWidth();
            })
        }
    }
</script>
